import * as types from './actionTypes';
import {
    fetchQuestionsAndAnswersSuccess,
    fetchQuestionsAndAnswersFailure
} from './actions';
import { showSuccess } from 'helpers/notification_helper';
import axiosInstance from 'pages/Utility/axiosInstance';
import { call, put,takeLatest } from 'redux-saga/effects';

const fetchQuestionsAndAnswersAPI=async(payload)=>{
    const response=await axiosInstance.get('V1/questions', { params: payload });
    return response.data;
};


//worker sagas

//fetch questions and answers

function* fetchQuestionsAndAnswersSaga(action){
    try{
        const result= yield call(fetchQuestionsAndAnswersAPI,action.payload);   
        yield put(fetchQuestionsAndAnswersSuccess(result));
    } catch(error){
        const errMsg=error.response.data || error.message;
         yield put(fetchQuestionsAndAnswersFailure(errMsg))
    }
}

export default function* questionAndAnswersSaga(){
 yield takeLatest(types.FETCH_QUESTION_AND_ANSWERS_REQUEST,fetchQuestionsAndAnswersSaga);
}